<div class="create-task-wrapper" id="frmCreateTask"> <!--style="display: block"-->
  <form class="create-task-container modal-content" cdkDragBoundary=".create-task-wrapper" cdkDrag>

    <!-- header -->
    <app-configurable-header
      cdkDragHandle
      [headingText]="'Select.createtask.edittasktxt' | translate"
      [variant]="'none'"
      [iconThree]="'cross'"
      (actionThree)="close()"
      [iconTwo]="'edit_note'"
      (actionTwo)="openMaintenanceForm(content)"
      [iconTwoDropdown]="false"
      [isCreateEditTaskHeader]="true"
      [tooltipThree]="'Close'"
      [tooltipTwo]="'Manage Work Order Form'"
    >
    </app-configurable-header>

    <!-- inputs (scrollable area) -->
    <div class="create-task-scrollable">

      <!-- top half - Scheduled inputs -->
      <div id="schedule-inputs" *ngIf="currentUser.soultionTiers[0][0].task_Prioritization && hasAdvancedFields && showUpperTools">

        <div>

          <!-- Resource List -->
          <div class="form-row" *ngIf="currentUser.soultionTiers[0][0].resource_Requirements_Check" style="margin-bottom:20px;">
            <div  class="form-group col narrow-group">
              <button name="resourcelistbtn" style="margin: 0.25em;"
                      *ngIf="currentUser.soultionTiers[0][0].resource_Requirements_Check" 
                      mat-stroked-button (click)="toggleResources()"
              >
                {{ "Select.createtask.resourcelistbtn" | translate }}
              </button> 
            </div>
            <div class="form-group col narrow-group">
              <form *ngIf="activityToolKitList.length > 0 && showResources" class="result-popup" style="background-color: #fff">
                <ul class="list-group">
                  <li *ngFor="let tool of activityToolKitList; let i = index" class="list-group-item d-flex justify-content-between align-items-center">
                    {{ tool.attributes.ToolName }}
                    <span class="badge badge-primary badge-pill">1</span>
                  </li>
                </ul>
              </form>
            </div>
          </div>

          <!-- schedule date, forecase icon, priority-->
          <div class="form-row">

            <!-- priortiy -->
            <div class="form-group col narrow-group">
              <mat-form-field appearance="outline" [ngClass]="{ 'empty-required': requiredStatus.Priority == 1 && (priority == null || (priority == '' && priority != 0)) }">
                <mat-label>
                  <span class="label-wrapper">{{ "Select.createtask.prioritytxt" | translate }} <span *ngIf="requiredStatus.Priority">★</span></span>
                </mat-label>
                <mat-select [disabled]="editCreateTaskForm.priority == false ? true : false" [(ngModel)]="priority" name="wrkpriority">
                  <mat-option [value]="0">
                    {{ "Select.createtask.prioritylowtxt" | translate }}
                  </mat-option>
                  <mat-option [value]="1">
                    {{ "Select.createtask.prioritymediumtxt" | translate }}
                  </mat-option>
                  <mat-option [value]="2">
                    {{ "Select.createtask.priorityhightxt" | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- scheduled date -->
            <div class="form-group col narrow-group" >
              <mat-form-field appearance="outline" [ngClass]="{ 'empty-required': requiredStatus.SheduledDate == 1 && (scheduled == null || (scheduled == '' && scheduled != 0)) }">
                <mat-label>
                  <span class="label-wrapper">Scheduled Date<span *ngIf="requiredStatus.SheduledDate">★</span></span>
                </mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  [disabled]="editCreateTaskForm.sheduledTime == false ? true : false && disableWeatherIcon"
                  placeholder="Scheduled Date"
                  [min]="todayDate"
                  [(ngModel)]="scheduled"
                  (ngModelChange)="dateTimeChanged()"
                  name="wrkshedule"
                  readonly="readonly"
                  autocomplete="off"
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error>Error</mat-error>
              </mat-form-field>
            </div>

            <!-- weather forecast icon -->
            <div class="form-group col narrow-group">
              <div class="form-group col-3">
                <div id="weatherIconDiv" class="w-icon w-icon-grey" (click)="showDetailTable()"></div>
              </div>
            </div>

            <!-- estimate and start -->
            <div class="form-group col narrow-group">
              <div style="display: flex; flex-direction: column;">
                <span>Estimated (hh:mm) <span style="font-weight: bolder; margin-left:5px;">{{dhours}}:{{dminutes}}</span></span>
                <button *ngIf="startTime == null" name="taskstarttime" style="margin-top: 2px" mat-stroked-button [disabled]="startTime != null ? true : false" (click)="startTask()">Start Task</button>
                <span *ngIf="startTime != null">Started {{ startTime | date : "short" }}</span>
              </div>
            </div>

          </div>

          <!-- Weather Detail -->
          <div class="form-group col">
            <div class="form-row">
              <div class="form-group col">
                <div *ngIf="showTable">
                  <div class="form-row">
                    <div class="form-group col"></div>

                    <div class="form-group col"></div>
                  </div>
                  <div class="form-row" *ngIf="showTable">
                    <div class="form-group col">
                      <table class="table table-bordered">
                        <thead>
                          <tr class="color-primary">
                            <th scope="col">#</th>
                            <th scope="col">{{ "Select.Weathertable.temperature" | translate }}</th>
                            <th scope="col">{{ "Select.Weathertable.wind" | translate }}</th>
                            <th scope="col">{{ "Select.Weathertable.humidity" | translate }}</th>
                            <th scope="col">{{ "Select.Weathertable.precipitation" | translate }}</th>
                            <th scope="col">{{ "Select.Weathertable.recommendation" | translate }}</th>
                          </tr>
                        </thead>
                        <tbody class="overflow-auto">
                          <tr *ngFor="let f of detailForecastData">
                            <th scope="row" class="text-center color-primary">{{ f.time }}</th>
                            <td class="text-center" [ngClass]="getColorClass(f.tempcolor)">{{ f.temp }}</td>
                            <td class="text-center" [ngClass]="getColorClass(f.windcolor)">{{ f.wind }}</td>
                            <td class="text-center" [ngClass]="getColorClass(f.humiditycolor)">
                              {{ f.humidity }}
                            </td>
                            <td class="text-center" [ngClass]="getColorClass(f.raincolor)">{{ f.rain }}</td>
                            <td class="text-center"><i [ngClass]="getRecommendationColorClass(f.tempcolor, f.windcolor, f.humiditycolor, f.raincolor)"></i></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

      </div>
        <div class="divider divider-aftersubheading"></div>
      </div>

      <!-- metadata and toggle button -->
      <div style="display: flex; justify-content: space-between ; margin:10px 0px;">
        <!-- metadata -->
        <span style="padding-top:5px;">
          <span style="margin-left: 2px; padding-right:2px;">Created {{ createdDate | date : "shortDate" }} </span>
          <span style="padding-right:2px;">by {{createdBy}}. </span>
          <span style="padding-right:2px;">{{assetId}} </span>
        </span>
        <!-- toggle upper tools -->
        <button mat-button (click)="toggleUpperTools()" *ngIf="currentUser.soultionTiers[0][0].task_Prioritization && hasAdvancedFields">
          {{toggleButtonValue}}
        </button>
      </div>

      <!-- bottom half - task detail -->
      <div id = "task-detail">

        <!-- row 1: work order, worker, reason, activity -->
        <div class="form-row">
          <!-- work order -->
          <div class="form-group col narrow-group">
            <mat-form-field appearance="outline" 
              [ngClass]="{ 'empty-required': requiredStatus.WorkOrder == 1 && (workorderID == null || (workorderID == '' && workorderID != 0)) }">
              <mat-label>
                <span 
                  [ngClass]="{ 'empty-required': requiredStatus.WorkOrder == 1 && (workorderID == null || (workorderID == '' && workorderID != 0)) }" class="label-wrapper">
                    {{ "Select.createtask.workorderidtxt" | translate }}<span *ngIf="requiredStatus.WorkOrder">★</span>
                </span>
              </mat-label>
              <input [disabled]="editCreateTaskForm.workorderID == false ? true : false" matInput [(ngModel)]="workorderID" type="text" id="userIdFirstWay" name="workorderid" />
              <mat-error>Error</mat-error>
            </mat-form-field>
          </div>
          <!-- worker -->
          <div class="form-group col narrow-group">
            <app-dropdown
              [isRequired]="requiredStatus.Worker"
              [label]="'Select.createtask.workertxt' | translate"
              [dropdownList]="workerList"
              [(ngModel)]="worker"
              [val]="worker"
              [isWorkerUsername]="true"
              (select)="workerChanged($event)"
            >               <!-- [tooltip]="'Select.createtask.workerinfoicontxt' | translate"   -->
            </app-dropdown>
          </div>
          <!-- reason -->
          <div class="form-group col narrow-group">
            <app-dropdown 
              [isRequired]="requiredStatus.Reason"
              [label]="'Select.createtask.reasontxt' | translate"
              [dropdownList]="reasonList"
              [val]="reason"
              [isReason]="true"
              (select)="reasonChanged($event)"
              [disableReasonDropdown]="editCreateTaskForm.reason == false ? true : false"
            >
            </app-dropdown>
          </div>
          <!-- activity -->
          <div *ngIf="activity" class="form-group col narrow-group">
            <app-dropdown
              [isRequired]="requiredStatus.Status"
              [label]="'Select.createtask.activitytxt' | translate"
              [dropdownList]="activityList"
              [val]="activity"
              [isActivity]="true"
              (select)="activityChange($event)"
              [disableActivityDropdown]="editCreateTaskForm.activity == false ? true : false"
            >
            </app-dropdown>
          </div>
        </div>

        <!-- row2: work order description, comment-->
        <div class="form-row">
          <!-- work order description -->
          <div class="form-group col">
            <mat-form-field appearance="outline" [ngClass]="{ 'empty-required': requiredStatus.WorkOrderDesc == 1 && (desc == null || (desc == '' && desc != 0)) }">
              <mat-label>
                <span class="label-wrapper" [ngClass]="{ 'empty-required': requiredStatus.WorkOrderDesc == 1 && (desc == null || (desc == '' && desc != 0)) }" >
                  {{ "Select.createtask.workorderdesctxt" | translate }} <span *ngIf="requiredStatus.WorkOrderDesc">★</span>
                </span>
              </mat-label>
              <textarea [disabled]="editCreateTaskForm.desc == false ? true : false" matInput [(ngModel)]="desc" type="text" name="wrkdesc" rows="3" maxlength="250"></textarea>
              <span *ngIf="desc" style="color: red">{{ 250 - desc.length + " characters remaining" }}</span>
              <mat-error>Error</mat-error>
            </mat-form-field>
          </div>
          <!-- comment -->
          <div class="form-group col">
            <mat-form-field appearance="outline" [ngClass]="{ 'empty-required': requiredStatus.Comment == 1 && (comments == null || (comments == '' && comments != 0)) }">
              <mat-label>
                <span class="label-wrapper" [ngClass]="{ 'empty-required': requiredStatus.Comment == 1 && (comments == null || (comments == '' && comments != 0)) }">
                  {{ "Select.createtask.commenttxt" | translate }} <span *ngIf="requiredStatus.Comment">★</span>
                </span>
              </mat-label>
              <textarea [disabled]="editCreateTaskForm.comments == false ? true : false" matInput [(ngModel)]="comments" type="text" name="comments" maxlength="250" rows="3"></textarea>
              <span *ngIf="comments" style="color: red">{{ 250 - comments.length + " characters remaining" }}</span>
              <mat-error>Error</mat-error>
            </mat-form-field>
          </div>
        </div>

      </div>

    </div>

    <!-- footer -->
    <div class="sms-form-footer" *ngIf="userIsDataEditor">
      
      <button
        style="margin: 4px"
        [disabled]="disabledSave"
        *ngIf="currentUser.rolePermissions.taskEditOpen"
        mat-button
        class="primary-button h7"
        title="{{ 'CreateTask.Tooltip.SaveForLater' | translate }}"
        (click)="saveTaskForLater()"
      >
        {{ "CreateTask.Tooltip.SaveForLater" | translate }}
      </button>

      <button
        style="margin: 4px"
        [disabled]="disabledSave"
        *ngIf="currentUser.rolePermissions.taskCompleteOpen"
        class="h7 inverse-button"
        mat-stroked-button
        title="{{ 'CreateTask.Tooltip.SaveTaskCompleted' | translate }}"
        (click)="saveAndCompleteTask()"
      >
        {{ "CreateTask.Tooltip.SaveTaskCompleted" | translate }}
      </button>

    </div>

  </form>
</div>




<!-- Work Order Defaults form -->
<ng-template id="frmManageWorkOrder" #content let-modal let-d="dismiss">
  <app-configurable-header [headingText]="'Select.manageworkorder.title' | translate" [variant]="'none'" [iconThree]="'cross'" (actionThree)="modal.dismiss('Cross click')"> </app-configurable-header>
  <div id="createtask" style="background-color: #ffffff">
    <form class="form-container1 formbg-d2 form-manageorder" style="position: relative; width: 94%; left: 3%">
      <h4 class="mb-1" style="padding-top: 16px; font-weight: bold">{{ "Select.manageworkorder.desc" | translate }}</h4>
      <div class="divider"></div>
      <p class="my-2" style="margin-top: 6px">{{ "Select.manageworkorder.desc2" | translate }}</p>

      <div class="form-row">
        <div class="form-group col">
          <mat-form-field appearance="outline">
            <mat-label>{{ "Select.manageworkorder.workorder" | translate }}</mat-label>
            <input matInput [(ngModel)]="defWorkOrder" type="text" name="wrkworkerid" />
            <mat-error>Error</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col">
          <app-dropdown 
            [label]="'Select.manageworkorder.worker' | translate" 
            [dropdownList]="workerList" 
            [val]="defWorker" 
            [isWorkerUsername]="true" 
            (select)="managedWorkerChanged($event)"> 
          </app-dropdown>
        </div>
        <div class="form-group col">
          <app-dropdown 
            [label]="'Select.manageworkorder.reason' | translate" 
            [dropdownList]="reasonList" 
            [val]="defReason" 
            [isReason]="true" 
            (select)="managedReasonChanged($event)"> 
          </app-dropdown>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col">
          <mat-form-field appearance="outline">
            <mat-label>{{ "Select.manageworkorder.workorderdesc" | translate }}</mat-label>
            <textarea matInput [(ngModel)]="defDesc" type="text" rows="3" name="wrkdesc"></textarea>
            <mat-error>Error</mat-error>
          </mat-form-field>
        </div>

        <div class="form-group col">
          <mat-form-field appearance="outline">
            <mat-label>{{ "Select.manageworkorder.comments" | translate }}</mat-label>
            <textarea matInput [(ngModel)]="defComments" type="text" rows="3" name="comments"></textarea>
            <mat-error>Error</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="divider"></div>
      <div class="sms-form-footer" *ngIf="userIsDataEditor">
        <button title="{{ 'Select.manageworkorder.clearbtn' | translate }}" style="margin: 4px" class="h7 primary-button" mat-button (click)="clearDef()">{{ "Select.manageworkorder.clearbtn" | translate }}</button>
        <button title="{{ 'Select.manageworkorder.savebtn' | translate }}" style="margin: 4px" mat-button class="h7 primary-button" (click)="saveWorkOrderDefaults()">
          {{ "Select.manageworkorder.savebtn" | translate }}
        </button>
        <button title="{{ 'Select.manageworkorder.cancelbtn' | translate }}" style="margin: 4px" mat-stroked-button class="h7 inverse-button" (click)="cancel()">
          {{ "Select.manageworkorder.cancelbtn" | translate }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
